import NumeroObjetLabel from '@/generated/controls/numeroObjet/NumeroObjetLabel.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: NumeroObjetLabel
})
